import { Field, Form, Formik } from "formik";
import "../add-edit-agreement.css";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import LoaderButton from "../../../../shared-components/button/loader-button";
import FormikFormInput from "../../../../shared-components/FormikFormHandlers/FormikFormInput";
import Label from "../../../../shared-components/label/label";
import FormikFormSelect from "../../../../shared-components/FormikFormHandlers/FormikFormSelect";
import { observer } from "mobx-react";
import FormikReactQuill from "../../../../shared-components/FormikFormHandlers/FormikFormReactQuill";
import {
  AddAgreementValidationSchema,
  EditAgreementValidationSchema,
} from "../../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import { getPlainTextLength } from "../../../../constants/imagePicker.helper";
import { ActionType } from "../../../../constants/enums/action-type-enum";
import { ModuleType } from "../../../../constants/enums/module-type-enum";
import { isOperationPermittedRoleBase } from "../../../../helpers/action-permission-helper";
import { getUserTypeFromLocalStorage } from "../../../../helpers/localstorage-helper";
import userTypeEnum from "../../../../constants/enums/user-type-enum";

const AddEditAgreementForm = (props: any) => {
  const { viewOnly } = props;
  return (
    <>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validationSchema={
          props.id > 0
            ? EditAgreementValidationSchema
            : AddAgreementValidationSchema
        }
        onSubmit={(values) => {
          let data = {
            ...values,
            IsValid: values.IsValid === "IsValid",
          };
          props.submitHandler(data);
        }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <div>
              <div className="row">
                {getUserTypeFromLocalStorage() !==
                  userTypeEnum[userTypeEnum.HeadQuarter] && (
                  <div className="col-sm-3">
                    <Label
                      className="label-style"
                      required={true}
                      label="business_type"
                    />
                    <Field
                      className="form-control"
                      name="BusinessTypeId"
                      options={props.buisnessTypeOptions}
                      as={FormikFormSelect}
                      disabled={
                        getUserTypeFromLocalStorage() ===
                        userTypeEnum[userTypeEnum.HeadQuarter]
                          ? true
                          : viewOnly
                      }
                    />
                  </div>
                )}
                <div className="col-sm-5">
                  <Label
                    className="label-style"
                    required={true}
                    label="agreement_name"
                  />
                  <Field
                    className="form-control"
                    name="AgreementName"
                    type="text"
                    disabled={props.id > 0}
                    // value={props.inputValues}
                    placeholder="enter_agreement_name"
                    as={FormikFormInput}
                  />
                </div>
                <div className="col-sm-4">
                  <Label className="label-style" label="status" />
                  <div className="d-flex align-items-center mt-2">
                    <div className="me-3">
                      <Field
                        className="form-check-input"
                        name="IsValid"
                        type="radio"
                        value="IsValid"
                        id="IsValid"
                        disabled={viewOnly}
                      />
                      <label className="form-check-label" htmlFor="IsValid">
                        <FormattedMessage id="valid" />
                      </label>
                    </div>
                    <div className="me-1">
                      <Field
                        className="form-check-input"
                        name="IsValid"
                        type="radio"
                        value="IsNotValid"
                        id="IsNotValid"
                        disabled={viewOnly}
                      />
                      <label className="form-check-label" htmlFor="IsNotValid">
                        <FormattedMessage id="invalid" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 mt-4 mb-3">
                <Field
                  type="text"
                  name="Content"
                  as={FormikReactQuill}
                  disabled={viewOnly}
                />
              </div>
              {/* <p className="small text-muted text-end mt-1">{`${
                values.Content ? getPlainTextLength(values.Content.length) : 0
              }/500`}</p> */}
            </div>
            <div className="text-center">
              {isOperationPermittedRoleBase(
                ModuleType.AgreementManegement,
                ActionType.Add
              ) && (
                <LoaderButton
                  type="submit"
                  isLoading={props.isLoading}
                  iconName="bi-check-lg"
                  className="me-2"
                  text={props.id > 0 ? "button_update" : "add"}
                />
              )}
              <Button
                variant="outline-danger"
                type="button"
                onClick={props.onCancel}
                disabled={props.isLoading}
              >
                <i className="bi bi-x-lg me-1"></i>
                <FormattedMessage id="button_cancel" />
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default observer(AddEditAgreementForm);
